/**
 * Footer Component
 * Displays data freshness information across all pages
 */

import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { API_BASE_URL } from '../config/env'

const Footer = () => {
  const { data } = useQuery({
    queryKey: ['data-freshness'],
    queryFn: async () => {
      const res = await fetch(`${API_BASE_URL}/data-freshness`)
      if (!res.ok) return null
      return res.json()
    },
    staleTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
  })

  const formatRefreshTime = (isoString) => {
    if (!isoString) return null
    const date = new Date(isoString)
    const now = new Date()
    const diffHours = Math.round((now - date) / (1000 * 60 * 60))

    const dateStr = date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
    const timeStr = date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })

    let ageStr
    if (diffHours < 1) ageStr = 'less than an hour ago'
    else if (diffHours < 24) ageStr = `${diffHours}h ago`
    else ageStr = `${Math.round(diffHours / 24)}d ago`

    return { dateStr, timeStr, ageStr, diffHours }
  }

  const refresh = data?.last_refresh ? formatRefreshTime(data.last_refresh) : null

  return (
    // print:hidden — S4: the printed sign-off pack is the document alone
    <footer className="print:hidden bg-bg2 border-t border-line mt-auto">
      <div className="cx-page py-2.5">
        <div className="flex items-center justify-center gap-2 font-mono text-[10.5px] text-mut2">
          {refresh ? (
            <>
              <span className={refresh.diffHours > 48 ? 'text-amber' : ''}>
                Data last refreshed: {refresh.dateStr} at {refresh.timeStr} ({refresh.ageStr})
              </span>
              {data?.pipeline_status && (
                <span className={data.pipeline_status === 'HEALTHY' ? 'text-good' : 'text-amber'}>
                  &bull; {data.pipeline_status}
                </span>
              )}
            </>
          ) : (
            <span>Data freshness unavailable</span>
          )}
        </div>
      </div>
    </footer>
  )
}

export default Footer
